/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from 'antd';

import useAuth from '../../hooks/useAuth';
import useAccountNavigate from '../../hooks/useAccountNavigate';
import Loading from './Loading';
import AppHeader from '../Header/Header';
import SidebarMenu from '../Sidebar/SidebarMenu';
import ContentArea from '../Content/ContentArea';
import FooterArea from '../Footer/FooterArea';
import { ProductsProvider } from '../../context/ProductsContext';
import ClickToCallWidget from '../ClickToCallWidget/ClickToCallWidget';
import HelpFloatButton from '../HelpFloatButton/HelpFloatButton';
import ClaimOfferModal from '../ClaimOffer/ClaimOfferModal';
// import GlobalCopilot from '../GlobalCopilot/GlobalCopilot';

const { Content, Sider } = Layout;

export default function PrivateLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const { navigate: accountNavigate } = useAccountNavigate();

  const navigatePath = (path) => {
    if (path) {
      const pathString = path.toLowerCase();
      const formattedPath = pathString.replace(/\s+/g, '-');
      accountNavigate(formattedPath);
    }
  };

  if (!user && !authLoading) {
    console.log('PrivateLayout: No user found, redirecting to login.');
    navigate('/auth/login');
    return null;
  }

  return authLoading ? (
    <Loading />
  ) : (
    <ProductsProvider>
      <Layout
        style={{
          minHeight: '100vh',
          maxHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <AppHeader className="app-header" />
        <Layout style={{ flex: 1, display: 'flex', overflow: 'hidden', minHeight: 0 }}>
          <Sider
            width="200px"
            theme="dark"
            collapsible
            collapsed={collapsed}
            onCollapse={() => setCollapsed(!collapsed)}
            style={{
              height: 'calc(100vh - 60px)',
              overflow: 'auto',
              zIndex: 20,
              position: 'relative',
            }}
          >
            <SidebarMenu
              navigatePath={navigatePath}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
            />
          </Sider>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
            }}
          >
            <ContentArea />
          </Content>
        </Layout>
        <FooterArea />
        <HelpFloatButton />
        <ClickToCallWidget />
        {/* Nua Assistant global temporalmente deshabilitado */}
        <ClaimOfferModal />
      </Layout>
    </ProductsProvider>
  );
}
